import React, {Suspense} from 'react'
import ReactDOM from 'react-dom'
import App from './App';

import "current-device";
import './i18n'
import './style/main.scss'
import Loader from "./components/Loader";
// import {publicRoutes} from "./routes";
// import {languages} from "./utils/lang";
// import {GAME_ROUTE} from "./utils/consts";
// import cookie from "js-cookie";

// if (window.location.pathname.indexOf(`/adm/`) === -1) {
//     languages.filter((lang) => lang.code === cookie.get('i18next') && languages.push(languages.splice(languages.indexOf(lang), 1)[0]));
//     publicRoutes.forEach(({path}) => {
//         languages.forEach(({code}) => {
//             if (window.location.pathname.indexOf(`${GAME_ROUTE}/`) !== -1) {
//                 if (/^\/[a-z]{2}\/game\/(?:([^]+?))\/?$/i.test(window.location.pathname)) {
//                     if (window.location.pathname.slice(-1) !== '/') {
//                         // /ru/game/234
//                         window.location.href = `${window.location.pathname}/`;
//                     }
//                 } else {
//                     if (window.location.pathname.slice(-1) !== '/') {
//                         // /game/234
//                         window.location.href = `/${code}${window.location.pathname}/`;
//                     } else {
//                         // /game/234/
//                         window.location.href = `/${code}${window.location.pathname}`;
//                     }
//                 }
//             } else {
//                 if ((window.location.pathname === path)
//                     || (window.location.pathname === `${path}/`)
//                     || (window.location.pathname === `/${code}${path === '/' ? '' : path}`)
//                 ) {
//                     window.location.href = `/${code}${path === '/' ? '' : path}/`;
//                 }
//             }
//         });
//     });
// }

ReactDOM.render(
    <Suspense fallback={<Loader/>}>
        <App/>
    </Suspense>,
    document.getElementById('root')
);
